import React, { useState } from "react";
import { connect } from "react-redux";
import T from "prop-types";
import { DataTable, Modal } from "MODULES/shared/components";
import {
  ADMIN,
  ACCOUNTING,
  QUALITY_CONTROL,
  ACCOUNTING_MANAGER,
  USER,
  ROLE,
  SUBROLE
} from "MODULES/users/constants";
import { Close, Header } from "MODULES/shared/components/Modal";
import UpdateStatusForm from "MODULES/Commissions/components/Search/UpdateStatusForm";
import UpdateCommissionForm from "MODULES/Commissions/components/Search/UpdateCommissionForm";
import Row from "./Row";

export function Table({ results, isLoading, canEdit, manager }) {
  const [commission, setCommission] = useState({});
  const [updateStatusModalOpen, setUpdateStatusModalOpen] = useState(false);
  const [updateOverride, setUpdateOverrideOpen] = useState(false);

  return (
    <div>
      {updateStatusModalOpen && (
        <Modal
          open={updateStatusModalOpen}
          close={() => setUpdateStatusModalOpen(false)}
          dialogClass="modal-sm"
        >
          <Header>
            <Close close={() => setUpdateStatusModalOpen(false)} />
            <h4 className="modal-title">Update Commission Status</h4>
          </Header>
          <UpdateStatusForm
            commission={commission}
            close={() => setUpdateStatusModalOpen(false)}
            enableReinitialize
          />
        </Modal>
      )}
      {updateOverride && (
        <Modal
          open={updateOverride}
          close={() => setUpdateOverrideOpen(false)}
          dialogClass="modal-sm"
        >
          <Header>
            <Close close={() => setUpdateOverrideOpen(false)} />
            <h4 className="modal-title">Override Commission</h4>
          </Header>
          <UpdateCommissionForm
            commission={commission}
            close={() => setUpdateOverrideOpen(false)}
            enableReinitialize
          />
        </Modal>
      )}
      <DataTable loading={isLoading}>
        <DataTable.Head>
          <th>Sale Date</th>
          <th>SO #</th>
          <th>Source</th>
          {canEdit && <th>Employee</th>}
          <th>Company Name</th>
          <th>Part #</th>
          <th>Serial #</th>
          <th>CD</th>
          <th className="text-right">Cost Ea.</th>
          <th className="text-center">QTY</th>
          <th className="text-right">Sale Ea.</th>
          <th className="text-right">Total Profit</th>
          <th>Seller</th>
          <th>Buyer</th>
          <th>Co-Buyer</th>
          <th>3rd Buyer</th>
          <th>Cust PO #</th>
          <th>Inv #</th>
          <th>Cust. Paid</th>
          <th className="text-right">Com. Paid</th>
          <th>Status</th>
          <th className="text-right">% Credit</th>
          <th className="text-right">Sales Credit</th>
          <th className="text-right">Profit Credit</th>
          <th className="text-right">Commission</th>
          <th className="text-center">Frt Conf</th>
          {canEdit && <th />}
        </DataTable.Head>
        <DataTable.Body>
          {results.map(r => (
            <Row
              key={r.id}
              commission={r}
              canEdit={canEdit}
              manager={manager}
              setUpdateStatusModalOpen={setUpdateStatusModalOpen}
              setUpdateOverrideOpen={setUpdateOverrideOpen}
              setCommission={setCommission}
            />
          ))}
        </DataTable.Body>
      </DataTable>
    </div>
  );
}

Table.propTypes = {
  results: T.arrayOf(T.shape({})).isRequired,
  isLoading: T.bool.isRequired,
  canEdit: T.bool,
  manager: T.bool.isRequired
};

export default connect(state => {
  const role = state.session.getIn([USER, ROLE]);
  const subrole = state.session.getIn([USER, SUBROLE]);

  return {
    canEdit:
      [ADMIN, QUALITY_CONTROL].includes(role) ||
      (role === ACCOUNTING && subrole === ACCOUNTING_MANAGER),
    manager: state.session.getIn(["user", "manager"]) || role === ADMIN
  };
})(Table);



// WEBPACK FOOTER //
// ./app/modules/Commissions/components/Search/Table.jsx